// src/layouts/brand/PricingLayout.tsx
import { Outlet } from "react-router-dom";
import { BrandMark } from "../../components/brand/BrandMark";

export function PricingLayout() {
  return (
    <div className="min-h-screen bg-muted">
      {/* Simple header without navigation */}
      <header className="bg-card shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <BrandMark />
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}

export default PricingLayout;
